"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loopToCsv = exports.loopToText = exports.loopToMjml = void 0;

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getLoopSectionEndBlock = function getLoopSectionEndBlock(x) {
  var ending = x;

  if (ending.indexOf(' ') !== -1) {
    ending = ending.split(' ')[0];
  }

  return ending;
};

var loopToMjml = function loopToMjml(item, blockRenderer, isTopLevelNode) {
  var items = '';
  (item.children || []).forEach(function (x) {
    // NOTE: the loop is a fake element so all children of a loop positioned at top level
    // are also considered at top level.
    items += blockRenderer(x, blockRenderer, isTopLevelNode);
  });
  return '{{#' + item.properties.loopPath + '}}' + items + '{{/' + getLoopSectionEndBlock(item.properties.loopPath) + '}}';
};

exports.loopToMjml = loopToMjml;

var loopToText = function loopToText(item, blockRenderer, isTopLevelNode) {
  var items = '';
  (item.children || []).forEach(function (x) {
    // NOTE: the loop is a fake element so all children of a loop positioned at top level
    // are also considered at top level.
    items += blockRenderer(x, blockRenderer, isTopLevelNode);
  });
  return '{{#' + item.properties.loopPath + '}}\r\n' + items + '{{/' + getLoopSectionEndBlock(item.properties.loopPath) + '}}\r\n' + '\r\n';
};

exports.loopToText = loopToText;

var loopToCsv = function loopToCsv(item, blockRenderer, isTopLevelNode, templateMetadata) {
  var headers = '';
  var items = '';

  if (templateMetadata.showHeaders) {
    (item.children || []).forEach(function (x) {
      headers += blockRenderer(x, blockRenderer, isTopLevelNode, templateMetadata);
    });
  }

  (item.children || []).forEach(function (x) {
    // make showHeaders false so that columnToCsv will consider 'text' and not 'header'
    items += blockRenderer(x, blockRenderer, isTopLevelNode, _objectSpread({}, templateMetadata, {
      showHeaders: false
    }));
  });
  return item.properties.loopPath ? headers + '{{#' + item.properties.loopPath + '}}' + items + '{{/' + getLoopSectionEndBlock(item.properties.loopPath) + '}}' : headers + items;
};

exports.loopToCsv = loopToCsv;